import {
  Component, ElementRef, EventEmitter,
  Inject, Input,
  NgModule, OnInit, Output, TemplateRef, ViewChild
} from '@angular/core';
import {CommonModule, DOCUMENT} from '@angular/common';
import {animate, state, style, transition, trigger} from '@angular/animations';

export interface Options {
  customOverlay?: boolean;
}

@Component({
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  selector: 'app-modal',
  animations: [
    trigger('showHide', [
      state('show', style({
        opacity: 1,
      })),
      state('hide', style({
        padding: 0,
        opacity: 0,
        height: 0
      })),
      transition('show => hide', [
        animate('0.3s')
      ]),
      transition('hide => show', [
        animate('0.2s')
      ]),
    ]),
  ],
})
export class ModalComponent implements OnInit {
  @ViewChild('modalOverlay') modalOverlay!: ElementRef;
  @ViewChild('modalBody') modalBody!: ElementRef;
  // closeBtnColor: string;
  options: Options = {
    customOverlay: false
  };
  isOpened: boolean= false;
  @Output() hidden: EventEmitter<any> = new EventEmitter<any>();
  @Output() showed: EventEmitter<any> = new EventEmitter<any>();
  @Input() body: TemplateRef<any> | undefined;
  @Input() head: TemplateRef<any> | undefined;
  @Input() footer: TemplateRef<any> | undefined;
  @Input() closeBtnColor: string = "";
  @Input() changeBodyOverflow = true;
  constructor(
    @Inject(DOCUMENT) private document: Document
  ) {}

  show = (opts: Options) => {
    this.modalBody.nativeElement.style.overflow = 'hidden';
    setTimeout(() => {
      this.modalBody.nativeElement.style.overflow = 'auto';
    }, 200);
    if (opts.customOverlay) {
      this.options.customOverlay = true;
    }
    this.isOpened = true;
    if (this.changeBodyOverflow) {
      this.document.documentElement.style.overflow = 'hidden';
    }
    this.showed.emit();
  }

  hide = () => {
    this.modalBody.nativeElement.style.overflow = 'hidden';
    this.options.customOverlay = false;
    this.isOpened = false;
    if (this.changeBodyOverflow) {
      this.document.documentElement.style.overflow = 'auto';
    }
    this.hidden.emit();
  }

  toggle = () => {
    this.isOpened ? this.hide() : this.show({customOverlay: this.options.customOverlay});
  }

  setBody = (value: TemplateRef<any>) => {
    this.body = value;
  }

  ngOnInit(): void {
  }

}

